import React from 'react';
import { PureButton } from '../../../../components';

export const DefaultButtons = ({ onCancel, onConfirm, translations }) => {
	return (
		<>
			<PureButton className="cancel-button" onClick={onCancel}>
				{translations.cancel}
			</PureButton>
			<PureButton className="apply-button" onClick={onConfirm}>
				{translations.apply}
			</PureButton>
		</>
	);
};

export const BlockedSwitchingButtons = ({ onClick, translations }) => {
	return (
		<PureButton className="ok-button" onClick={onClick}>
			{translations.ok}
		</PureButton>
	);
};
